<template>
  <div>
    <div class="inline-block pr-4 pb-4 w-1/2">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        {{ label }}
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <p
        v-if="formattedValue"
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black"
      >
        {{ formattedValue }}
      </p>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellMultiSelect",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      // this must be array of strings
      // eg - [ "ENG" ]
      type: Array,
      validator: prop => prop.every(e => typeof e === "string")
    },
    options: {
      // this must be array of objects
      // with each object having atleast 2 props - text and value
      // eg - [ { text: "English", value: "ENG" } ]
      type: Array,
      validator: prop =>
        prop.every(e => typeof e === "object" && e["text"] && e["value"])
    }
  },
  computed: {
    formattedValue() {
      return this.options
        .filter(option => this.value && this.value.includes(option.value))
        .map(opt => opt.text)
        .join(", ");
    }
  }
};
</script>

<style lang="scss" scoped></style>
